// React and Redux
import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// Action
import { setAlertMessage } from "../../actions";
import { activePayPalCharge } from "../module/store/paypal/paymentSuccess";

// Libs
import { default as Loadable } from "../../components/_Shared/commonLoadable";
import { browserHistory } from "react-router";

// Style
import "./Paypal.css";

const Paypal = ({ location, setAlertMessage, activePayPalCharge }) => {
  useEffect(() => {
    const { pathname, query } = location;
    // Getting the last element of the URL ex: "/payment_success"
    const paypalPaymentUrl = pathname.substring(pathname.lastIndexOf("/"));

    if (paypalPaymentUrl === "/payment_cancel") {
      setAlertMessage(
        "Something went wrong. Please, contact our support.",
        "error"
      );
      browserHistory.push("/settings/plan");
    } else {
      activePayPalCharge(query.token);
      browserHistory.push("/search");
    }
  }, []);

  return (
    <div className="paypal__container">
      <Loadable active={true} text="Upgrading plan..." />
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setAlertMessage, activePayPalCharge }, dispatch);
}

export default connect(
  null,
  mapDispatchToProps
)(Paypal);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/Paypal.js